import { render, staticRenderFns } from "./Decoupe.vue?vue&type=template&id=3c6d454c&"
import script from "./Decoupe.vue?vue&type=script&lang=js&"
export * from "./Decoupe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Decoupe.vue"
export default component.exports